import React, { Component, PropTypes } from 'react';
import { DataStoreDispatcher } from '../../lib/frankly';

let didInitialChartbeatScriptLoad = false;

class Chartbeat extends Component {

  static propTypes = {
    uid: PropTypes.number.isRequired,
    domain: PropTypes.string,
    flickerControl: PropTypes.bool,
    useCanonical: PropTypes.bool,
    initialScriptUrl: PropTypes.string,
    finalScriptUrl: PropTypes.string
  }

  static contextTypes = {
    flux: PropTypes.object.isRequired
  }

  static defaultProps = {
    initialScriptUrl: "https://static.chartbeat.com/js/chartbeat_mab.js",
    finalScriptUrl: "https://static.chartbeat.com/js/chartbeat.js",
    uid: '',
    domain: '',
    flickerControl: false,
    useCanonical: false
  }

  componentWillMount() {
    const {
      finalScriptUrl,
      uid,
      domain,
      flickerControl,
      useCanonical
      } = this.props;

    if (typeof window !== 'undefined') {
      const chartbeatConfig = window['_sf_async_config'] || {};

      chartbeatConfig.uid = uid;
      chartbeatConfig.domain = domain;
      chartbeatConfig.flickerControl = flickerControl;
      chartbeatConfig.useCanonical = useCanonical;

      window['_sf_async_config'] = chartbeatConfig;
    }

    // Run the final chartbeat code on load, as per the documentation
    if (typeof window !== 'undefined') {
      window.addEventListener('load', () => {
        this.loadFinalScript(finalScriptUrl);
      });
    }
  }

  loadInitialScript(chartbeatDomElement) {
    const {
      initialScriptUrl
      } = this.props;

    if (!didInitialChartbeatScriptLoad) {
      if (initialScriptUrl && typeof document !== 'undefined') {
        const initialChartbeatScriptElement = document.createElement('script');

        initialChartbeatScriptElement.type = 'text/javascript';
        initialChartbeatScriptElement.src = initialScriptUrl;
        initialChartbeatScriptElement.async = true;

        chartbeatDomElement.appendChild(initialChartbeatScriptElement);
      }

      didInitialChartbeatScriptLoad = true;
    }
  }

  loadFinalScript(finalScriptUrl) {
    const { flux } = this.context;

    if (finalScriptUrl && typeof window !== 'undefined' && typeof document !== 'undefined') {
      // Get sections and authors
      const contentClassification = flux.getStore('ContentClassification').getState().contentClassification || '';
      const articleDataStoreDispatcher = new DataStoreDispatcher('franklyinc.com/article');
      const authors = articleDataStoreDispatcher.get('authors') || '';
      const chartbeatConfig = window['_sf_async_config'] || {};
      chartbeatConfig.sections = contentClassification;
      chartbeatConfig.authors = this.formatStringForChartbeatConsumption(authors);

      window['_sf_startpt'] = window['frnStartLoadTime'];
      window['_sf_endpt'] = (new Date()).getTime();
      window['_sf_async_config'] = chartbeatConfig;

      const finalChartbeatScriptElement = document.createElement('script');
      finalChartbeatScriptElement.type = 'text/javascript';
      finalChartbeatScriptElement.src = finalScriptUrl;
      finalChartbeatScriptElement.async = true;

      document.body.appendChild(finalChartbeatScriptElement);
    }
  }

  formatStringForChartbeatConsumption(str) {
    return str.replace(/, /g, ",").replace(/ & /g, ",");
  }

  render() {
    return (
      <span id="Chartbeat" ref={el => {this.loadInitialScript(el);}} />
    );
  }
}

export default Chartbeat;



// WEBPACK FOOTER //
// ./app/components/analytics/Chartbeat.js